<template>
  <div class="background-01">
    <v-layout row wrap text-xs-right>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Qué es el ingreso?" titleLevel="h1">
          <template slot="partOne">¿Qué es <br></template>
              <!-- <template slot="partTwo"></template> -->
              <template slot="partThree"> el ingreso?</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 sm2 text-xs-right class="hidden-xs-only ">
        <image-app class="animated fadeInRight" :imaSize="250" imaSrc="design/banco1-1-3-2" imaAlt=""></image-app>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Qué es el ingreso?'" videoEmbed="ADMINISTRACIONDINERO19QueEsIngreso (50).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="350" imaSrc="contenido/diapositiva_20" imaAlt="Persona sosteniendo en la mano sus ingresos"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Es el
            <strong>dinero recibido</strong> por una persona. Puede provenir de diferentes fuentes como
            <strong>salarios, comisiones, ingresos por renta, intereses</strong>, entre otros.
            <br><br>
            Las familias pueden recibir uno, dos o más ingresos. Estos además pueden ser
            <strong>fijos</strong> o
            <strong>variables</strong>.
        </p>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-19.vue?52b72373